export interface Conversation {
  id: string;
  title: string;
  created_at: string;
  updated_at: string;
  user_id?: string;
  metadata?: Record<string, any>;
  owner_id?: string;
  messages: Message[];
}

export interface Message {
  id: string;
  conversation_id: string;
  content: string;
  role: MessageRole;
  created_at: string;
  traces?: Trace[];
  metadata?: MetadataInterface;
  owner_id?: string;

}

export type CopilotExecutionStatus =
  | 'idle'
  | 'queued'
  | 'running'
  | 'waiting_for_input';

export type CopilotRunConnectionStatus =
  | 'submitting'
  | 'connecting'
  | 'streaming'
  | 'reconnecting'
  | 'reconciling'
  | 'disconnected';

export interface CopilotActiveRun {
  runId: string;
  streamUrl: string;
  status: CopilotRunConnectionStatus;
  attempt: number;
  startedAt: string;
  lastEventId?: string;
  error?: string;
}

export enum MessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
  SYSTEM = 'system'
}

export interface MetadataInterface {
  temporary?: boolean;
  finalized?: boolean;
  error?: boolean;
  file_name?: string;
  trace_id?: string;
  [key: string]: any;
}

export interface Trace {
  index?: number;
  reasoning?: string;
  rationale?: string;
  toolUsage?: unknown;
  type?: string;
  label?: string;
  value?: string;
  data?: Record<string, any>;
  timestamp?: string;
}


export interface PaginatedResult<T> {
  items: T[];
  pagination: {
    totalPages: number;
    totalItems: number;
    hasMore: boolean;
    isLoading: boolean;
    limit: number;
    currentPage: number;
  };
}

export type TraceData = {
  content?: {
    trace?: {
      orchestrationTrace?: {
        modelInvocationOutput?: {
          rawResponse?: string | {
            content?: Array<{
              text?: string;
              reasoningText?: string;
            }>;
          };
          traceId?: string;
        };
        invocationInput?: string | {
          actionGroupInvocationInput?: unknown;
        };
        rationale?: {
          text?: string;
        };
      };
    };
  };
};
